import React, {useEffect, FC} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Link} from 'react-router-dom';

import {
    IEntityMeta, IFieldMeta, loadMetadata, METADATA_MODULE,
} from 'entities/metadata';
import {EEntityType} from 'shared/constants/entities';
import {useAppSelector} from 'store/config/hooks';
import {TAppState} from 'store/config/types';
import {pushCrumb, selectBreadcrumbsData} from 'store/slices/breadcrumbs-slice';

interface IBreadcrumbItemProps {
    field: IFieldMeta;
    record: Record<string, any>;
    entityName: string;
    entityType?: EEntityType;
    handleBreadcrumbsEntityName?: (newEntityName: string, metaTable: IEntityMeta) => void;
}

export const BreadcrumbItem: FC<IBreadcrumbItemProps> = ({
    field,
    record,
    entityType,
    entityName,
    handleBreadcrumbsEntityName,
}: IBreadcrumbItemProps) => {
    const dispatch = useDispatch();
    const metaTable = useSelector(
        (state: TAppState) => state[METADATA_MODULE]?.[field?.breadcrumbsEntityName || '']
            ?.[entityType || EEntityType.TABLE],
    );
    const breadcrumbs = useAppSelector(selectBreadcrumbsData(entityName));
    let newEntityTypeData = {};
    breadcrumbs?.forEach(crumbItem => {
        if (crumbItem?.children) {
            crumbItem.children.forEach(childrenItem => {
                newEntityTypeData = {...newEntityTypeData, [childrenItem.key]: childrenItem?.params};
            });
        }
    });
    useEffect(() => {
        if (field?.breadcrumbsEntityName) {
            dispatch(loadMetadata(field.breadcrumbsEntityName, EEntityType.TABLE));
        }
    }, [metaTable]);

    const handlerChange = () => {
        dispatch(pushCrumb({
            entityName,
            crumb: {
                key: record?.id,
                label: record[field?.key],
                path: record.id,
            },
        }));

        if (field?.breadcrumbsEntityName && metaTable && handleBreadcrumbsEntityName) {
            handleBreadcrumbsEntityName(field?.breadcrumbsEntityName, metaTable);
        }
    };
    return (
        <Link
            to={entityName}
            onClick={handlerChange}
        >
            {record[field?.key]}
        </Link>
    );
};
